import { toast } from "sonner";
import { Copy, Eye, Link2 } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import OfferMaker from "./OfferMaker";
import InterestedList from "./InterestedList";

export default function ShareLink({ slug, packages = [], interested }) {
  if (!slug) return null;
  const url = `${window.location.origin}/c/${slug}`;
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copiat")).catch(() => toast.error("Copiază manual linkul"));
  const wa = `https://wa.me/?text=${encodeURIComponent(`Bună ziua! Vă trimit oferta Medavita Instant Bond Repair: ${url}`)}`;
  return (
    <div className="share-box" data-testid="share-link-box">
      <div className="st-section-title"><Link2 size={12} /> Linkul tău pentru clienți</div>
      <code data-testid="share-link-url">{url}</code>
      <div className="share-actions">
        <button type="button" className="st-btn st-btn--light" onClick={copy} data-testid="share-link-copy-btn"><Copy size={14} /> Copiază</button>
        <a className="st-btn st-btn--ghost" href={wa} target="_blank" rel="noopener noreferrer" data-testid="share-link-whatsapp-btn"><WhatsAppGlyph /> Trimite pe WhatsApp</a>
        <a className="st-btn st-btn--ghost" href={`/c/${slug}?preview=1`} target="_blank" rel="noopener noreferrer" data-testid="share-link-preview-btn"><Eye size={14} /> Vezi ca un client</a>
      </div>
      <p className="st-hint">Clientul deschide fără parolă, vede catalogul cu numele și telefonul tău și nu poate modifica nimic.</p>
      {packages.length > 0 && <OfferMaker url={url} packages={packages} />}
      {interested && <InterestedList />}
    </div>
  );
}
